import React from "react";
import { BiCopyright } from "react-icons/bi";



const Footer = () => {
  return (
    <div name ="contact"
    className="md:flex md-h-screen w-full py-2 items-center justify-center mx-auto text-sm text-center text-white bg-gradient-to-r from-sky-950 via-slate-800 to-slate-900 flex flex-col">
  <span className="flex items-center space-x-1">
    <BiCopyright size={17} />
    <span>2023 Eden Kefale | All rights reserved.</span>
  </span>
  <div>
    Developed by
    <a
      href="https://www.linkedin.com/in/edenkefale/"
      className="text-white hover:underline ml-1"
      target="_blank"
      rel="noopener noreferrer"
    >
      Eden Kefale
    </a>
  </div>
</div>

     
  
  )
}

export default Footer;